import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mpstore__panel" }
const _hoisted_2 = { class: "mpstore__head" }
const _hoisted_3 = { class: "mpstore__head-actions" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "mpstore__state"
}
const _hoisted_6 = {
  key: 1,
  class: "mpstore__state is-error"
}
const _hoisted_7 = {
  key: 2,
  class: "mpstore__scroll"
}
const _hoisted_8 = { class: "mpstore__top" }
const _hoisted_9 = { class: "mpstore__gallery" }
const _hoisted_10 = { class: "mpstore__main" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "mpstore__main-empty"
}
const _hoisted_13 = {
  key: 2,
  class: "mpstore__badge"
}
const _hoisted_14 = {
  key: 0,
  class: "mpstore__thumbs"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "mpstore__buy" }
const _hoisted_18 = { class: "mpstore__store" }
const _hoisted_19 = { class: "mpstore__cat" }
const _hoisted_20 = { class: "mpstore__name" }
const _hoisted_21 = {
  key: 0,
  class: "mpstore__summary"
}
const _hoisted_22 = { class: "mpstore__rating" }
const _hoisted_23 = { class: "mpstore__price" }
const _hoisted_24 = { class: "mpstore__info" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = {
  key: 1,
  class: "mpstore__options"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  class: "mpstore__tabs",
  role: "tablist",
  "aria-label": "상품 정보 탭"
}
const _hoisted_34 = ["aria-selected", "onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "mpstore__section" }
const _hoisted_38 = {
  key: 0,
  class: "mpstore__spec"
}
const _hoisted_39 = {
  key: 1,
  class: "mpstore__empty"
}
const _hoisted_40 = {
  key: 2,
  class: "mpstore__desc"
}
const _hoisted_41 = {
  key: 3,
  class: "mpstore__blocks"
}
const _hoisted_42 = {
  key: 0,
  class: "mpstore__block-heading"
}
const _hoisted_43 = {
  key: 1,
  class: "mpstore__block-text"
}
const _hoisted_44 = {
  key: 2,
  class: "mpstore__block-notice"
}
const _hoisted_45 = {
  key: 3,
  class: "mpstore__block-image"
}
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 4,
  class: "mpstore__empty"
}
const _hoisted_49 = { class: "mpstore__section" }
const _hoisted_50 = {
  key: 0,
  class: "mpstore__list"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = {
  key: 1,
  class: "mpstore__reply"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 1,
  class: "mpstore__empty"
}
const _hoisted_56 = { class: "mpstore__section" }
const _hoisted_57 = {
  key: 0,
  class: "mpstore__list"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 0,
  class: "mpstore__secret-tag"
}
const _hoisted_60 = {
  key: 0,
  class: "mpstore__reply"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "mpstore__pending"
}
const _hoisted_63 = {
  key: 1,
  class: "mpstore__empty"
}
const _hoisted_64 = { class: "mpstore__section" }
const _hoisted_65 = { class: "mpstore__spec" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 2 }
const _hoisted_69 = {
  key: 0,
  class: "mpstore__policy-text"
}
const _hoisted_70 = ["innerHTML"]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import MallOrderPackMark from '@/components/mall/MallOrderPackMark.vue'
import { fetchAdminProduct } from '@/api/admin'
import { fetchSellerProduct, toMallProduct } from '@/api/mallProduct'
import { formatPrice, type MallProduct } from '@/constants/mallProducts'
import { useContentSnippets, useSameDayCutoffText, SNIPPET_FALLBACKS } from '@/composables/useContentSnippets'
import { mallProductPath } from '@/constants/mall'
import { formatShippingFeeAmount } from '@/utils/mallShipping'
import { formatMinOrderLabel, formatShippingChargeLabel, formatStockCount, isOrderPack } from '@/utils/mallSell'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageProductStorefrontModal',
  props: {
    code: {},
    audience: {},
    mallOpen: { type: Boolean },
    initialTab: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { snippet, loadSnippets } = useContentSnippets()

const loading = ref(true)
const error = ref('')
const product = ref<MallProduct | null>(null)
const { sameDayCutoffText } = useSameDayCutoffText(() => product.value?.storeCutoff)
const activeIndex = ref(0)
const activeTab = ref<'detail' | 'review' | 'qna' | 'shipping'>(props.initialTab || 'detail')

watch(
  () => props.initialTab,
  (tab) => {
    if (tab) activeTab.value = tab
  },
)

const tabs = [
  { id: 'detail' as const, label: '상세정보' },
  { id: 'review' as const, label: '구매후기' },
  { id: 'qna' as const, label: '상품문의' },
  { id: 'shipping' as const, label: '배송/교환' },
]

const images = computed(() => {
  const item = product.value
  if (!item) return [] as string[]
  const list = item.images?.length ? item.images : [item.image]
  return list.filter(Boolean)
})

const activeImage = computed(() => images.value[activeIndex.value] ?? images.value[0] ?? '')

const blocks = computed(() => product.value?.blocks ?? [])

const shippingText = computed(() =>
  product.value ? formatShippingChargeLabel(product.value) : formatShippingFeeAmount(0),
)

const returnShippingText = computed(() =>
  formatShippingFeeAmount(product.value?.storeReturnFee),
)

const returnPolicyHtml = computed(
  () => snippet('mall.product.return_policy') || SNIPPET_FALLBACKS['mall.product.return_policy'],
)

const mallHref = computed(() => {
  if (!props.mallOpen || !product.value) return ''
  return mallProductPath(product.value.id)
})

async function load() {
  const code = props.code.trim()
  if (!code) {
    error.value = '상품 코드가 없습니다.'
    loading.value = false
    return
  }

  loading.value = true
  error.value = ''
  product.value = null
  activeIndex.value = 0
  activeTab.value = 'detail'

  try {
    const detail =
      props.audience === 'admin' ? await fetchAdminProduct(code) : await fetchSellerProduct(code)
    product.value = toMallProduct(detail)
  } catch (err) {
    error.value = err instanceof Error ? err.message : '상품을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    event.preventDefault()
    emit('close')
  }
}

watch(
  () => [props.code, props.audience] as const,
  () => {
    void load()
  },
)

watch(images, () => {
  activeIndex.value = 0
})

onMounted(() => {
  document.addEventListener('keydown', onKeydown)
  void loadSnippets(['mall.product.return_policy', 'mall.product.same_day_cutoff'])
  void load()
})

onUnmounted(() => {
  document.removeEventListener('keydown', onKeydown)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mpstore",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "몰 상품 미리보기",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mpstore__head-text" }, [
          _createElementVNode("h2", null, "몰 미리보기"),
          _createElementVNode("p", null, "구매자에게 보이는 상세 · 후기 · 문의입니다. 구매·작성은 되지 않습니다.")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          (mallHref.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "mpstore__mall-link",
                href: mallHref.value,
                target: "_blank",
                rel: "noopener noreferrer"
              }, " 몰에서 열기 ", 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "mpstore__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, [
            _createVNode(AppIcon, {
              icon: "mdi-close",
              size: 20
            })
          ])
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 28
            }),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "상품을 불러오는 중입니다…", -1))
          ]))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-circle-outline",
                size: 28
              }),
              _createElementVNode("p", null, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                type: "button",
                class: "mpstore__retry",
                onClick: load
              }, "다시 시도")
            ]))
          : (product.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (activeImage.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: activeImage.value,
                            alt: product.value.name
                          }, null, 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(AppIcon, {
                              icon: "mdi-image-outline",
                              size: 34
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "등록된 이미지가 없습니다", -1))
                          ])),
                      (product.value.badge)
                        ? (_openBlock(), _createElementBlock("em", _hoisted_13, _toDisplayString(product.value.badge), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (images.value.length > 1)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: image }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass({ 'is-active': index === activeIndex.value }),
                                onClick: ($event: any) => (activeIndex.value = index)
                              }, [
                                _createElementVNode("img", {
                                  src: image,
                                  alt: `${product.value.name} 이미지 ${index + 1}`
                                }, null, 8, _hoisted_16)
                              ], 10, _hoisted_15)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, [
                      _createVNode(AppIcon, {
                        icon: "mdi-storefront-outline",
                        size: 15
                      }),
                      _createTextVNode(" " + _toDisplayString(product.value.storeName || '스토어') + " ", 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(product.value.category), 1)
                    ]),
                    _createElementVNode("h3", _hoisted_20, _toDisplayString(product.value.name), 1),
                    (product.value.summary)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(product.value.summary), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_22, [
                      _createVNode(AppIcon, {
                        icon: "mdi-star",
                        size: 16
                      }),
                      _createElementVNode("strong", null, _toDisplayString(product.value.rating.toFixed(1)), 1),
                      _createElementVNode("span", null, "후기 " + _toDisplayString(_unref(formatPrice)(product.value.reviewCount)), 1),
                      _createElementVNode("span", null, "판매 " + _toDisplayString(_unref(formatPrice)(product.value.soldCount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(product.value.price)), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "원", -1))
                    ]),
                    _createElementVNode("dl", _hoisted_24, [
                      (product.value.unit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[6] || (_cache[6] = _createElementVNode("dt", null, "구성", -1)),
                            _createElementVNode("dd", null, _toDisplayString(product.value.unit), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("dt", null, "배송비", -1)),
                        _createElementVNode("dd", null, _toDisplayString(shippingText.value), 1)
                      ]),
                      (product.value.leadTime)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _cache[8] || (_cache[8] = _createElementVNode("dt", null, "출고", -1)),
                            _createElementVNode("dd", null, _toDisplayString(product.value.leadTime), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(sameDayCutoffText))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _cache[9] || (_cache[9] = _createElementVNode("dt", null, "당일 출고", -1)),
                            _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(isOrderPack)(product.value.orderStep))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "주문", -1)),
                            _createElementVNode("dd", null, [
                              _createVNode(MallOrderPackMark, {
                                size: "inline",
                                "order-step": product.value.orderStep || 1,
                                "sell-unit": product.value.sellUnit
                              }, null, 8, ["order-step", "sell-unit"])
                            ])
                          ]))
                        : (product.value.minOrder > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _cache[11] || (_cache[11] = _createElementVNode("dt", null, "최소 주문", -1)),
                              _createElementVNode("dd", null, _toDisplayString(_unref(formatMinOrderLabel)(product.value.minOrder, product.value.sellUnit)) + "부터", 1)
                            ]))
                          : _createCommentVNode("", true),
                      (product.value.origin || product.value.maker)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "원산지 · 제조", -1)),
                            _createElementVNode("dd", null, _toDisplayString([product.value.origin, product.value.maker].filter(Boolean).join(' · ')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("dt", null, "재고", -1)),
                        _createElementVNode("dd", {
                          class: _normalizeClass({ 'is-warn': (product.value.stock ?? 0) <= 0 })
                        }, _toDisplayString((product.value.stock ?? 0) > 0
                        ? _unref(formatStockCount)(product.value.stock ?? 0, product.value.sellUnit)
                        : '재고 없음 (품절 노출)'), 3)
                      ])
                    ]),
                    (product.value.options?.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.options, (option, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: `${option.group}-${option.name}-${index}`
                            }, [
                              _createElementVNode("span", null, _toDisplayString(option.group) + " · " + _toDisplayString(option.name), 1),
                              (option.extra)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_32, "+" + _toDisplayString(_unref(formatPrice)(option.extra)) + "원", 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"mpstore__cta\"><span class=\"mpstore__cta-buy\">바로구매</span><span class=\"mpstore__cta-wish\">찜하기</span><span class=\"mpstore__cta-cart\">장바구니</span></div><p class=\"mpstore__cta-note\">미리보기에서는 구매·작성 버튼이 동작하지 않습니다.</p>", 2))
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                    return _createElementVNode("button", {
                      key: tab.id,
                      type: "button",
                      role: "tab",
                      class: _normalizeClass(["mpstore__tab", { 'is-active': activeTab.value === tab.id }]),
                      "aria-selected": activeTab.value === tab.id,
                      onClick: ($event: any) => (activeTab.value = tab.id)
                    }, [
                      _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                      (tab.id === 'review')
                        ? (_openBlock(), _createElementBlock("em", _hoisted_35, _toDisplayString(product.value.reviewCount), 1))
                        : (tab.id === 'qna')
                          ? (_openBlock(), _createElementBlock("em", _hoisted_36, _toDisplayString((product.value.qnas || []).length), 1))
                          : _createCommentVNode("", true)
                    ], 10, _hoisted_34)
                  }), 64))
                ]),
                _withDirectives(_createElementVNode("section", _hoisted_37, [
                  _cache[15] || (_cache[15] = _createElementVNode("h4", null, "상품 정보", -1)),
                  (product.value.highlights.length)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.highlights, (spec) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: spec.label
                          }, [
                            _createElementVNode("dt", null, _toDisplayString(spec.label), 1),
                            _createElementVNode("dd", null, _toDisplayString(spec.value), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_39, "등록된 요약 정보가 없습니다.")),
                  _cache[16] || (_cache[16] = _createElementVNode("h4", null, "상세 설명", -1)),
                  (product.value.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(product.value.description), 1))
                    : _createCommentVNode("", true),
                  (blocks.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blocks.value, (block, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (block.type === 'HEADING')
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_42, _toDisplayString(block.text), 1))
                              : (block.type === 'TEXT')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(block.text), 1))
                                : (block.type === 'NOTICE')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                                      _createVNode(AppIcon, {
                                        icon: "mdi-information-outline",
                                        size: 16
                                      }),
                                      _createTextVNode(" " + _toDisplayString(block.text), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("figure", _hoisted_45, [
                                      _createElementVNode("img", {
                                        src: block.imageUrl,
                                        alt: block.alt || product.value.name
                                      }, null, 8, _hoisted_46),
                                      (block.alt)
                                        ? (_openBlock(), _createElementBlock("figcaption", _hoisted_47, _toDisplayString(block.alt), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                          ], 64))
                        }), 128))
                      ]))
                    : (!product.value.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_48, "상세 설명이 없습니다."))
                      : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, activeTab.value === 'detail']
                ]),
                _withDirectives(_createElementVNode("section", _hoisted_49, [
                  _createElementVNode("h4", null, "구매후기 " + _toDisplayString(product.value.reviewCount), 1),
                  (product.value.reviews.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.reviews, (review) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: review.id,
                            class: "mpstore__card"
                          }, [
                            _createElementVNode("header", null, [
                              _createElementVNode("strong", null, _toDisplayString(review.author), 1),
                              (review.org)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(review.org), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("em", null, "★ " + _toDisplayString(review.rating), 1),
                              _createElementVNode("time", null, _toDisplayString(review.date), 1)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(review.content), 1),
                            (review.image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: review.image,
                                  alt: `${product.value.name} 후기 사진`
                                }, null, 8, _hoisted_52))
                              : _createCommentVNode("", true),
                            (review.reply)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                  _cache[17] || (_cache[17] = _createElementVNode("strong", null, "판매자 답변", -1)),
                                  _createElementVNode("p", null, _toDisplayString(review.reply), 1),
                                  (review.repliedAt)
                                    ? (_openBlock(), _createElementBlock("time", _hoisted_54, _toDisplayString(review.repliedAt), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_55, "등록된 구매후기가 없습니다."))
                ], 512), [
                  [_vShow, activeTab.value === 'review']
                ]),
                _withDirectives(_createElementVNode("section", _hoisted_56, [
                  _createElementVNode("h4", null, "상품문의 " + _toDisplayString((product.value.qnas || []).length), 1),
                  ((product.value.qnas || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.qnas || [], (item) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: item.id,
                            class: "mpstore__card"
                          }, [
                            _createElementVNode("header", null, [
                              _createElementVNode("strong", null, _toDisplayString(item.secret ? '비밀문의' : item.author), 1),
                              (!item.secret && item.org)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(item.org), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("time", null, _toDisplayString(item.date), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _cache[18] || (_cache[18] = _createElementVNode("strong", { class: "mpstore__q" }, "Q.", -1)),
                              (item.secret)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_59, "비밀"))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.question), 1)
                            ]),
                            (item.answer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                  _cache[19] || (_cache[19] = _createElementVNode("strong", null, "A. 답변", -1)),
                                  _createElementVNode("p", null, _toDisplayString(item.answer), 1),
                                  (item.answeredAt)
                                    ? (_openBlock(), _createElementBlock("time", _hoisted_61, _toDisplayString(item.answeredAt), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_62, "답변 대기 중"))
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_63, "등록된 상품문의가 없습니다."))
                ], 512), [
                  [_vShow, activeTab.value === 'qna']
                ]),
                _withDirectives(_createElementVNode("section", _hoisted_64, [
                  _cache[24] || (_cache[24] = _createElementVNode("h4", null, "배송 · 교환 · 반품", -1)),
                  _createElementVNode("dl", _hoisted_65, [
                    _createElementVNode("div", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("dt", null, "배송비", -1)),
                      _createElementVNode("dd", null, _toDisplayString(shippingText.value), 1)
                    ]),
                    (product.value.leadTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _cache[21] || (_cache[21] = _createElementVNode("dt", null, "출고", -1)),
                          _createElementVNode("dd", null, _toDisplayString(product.value.leadTime), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(sameDayCutoffText))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _cache[22] || (_cache[22] = _createElementVNode("dt", null, "당일 출고", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_unref(sameDayCutoffText)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (product.value.sellerCode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _cache[23] || (_cache[23] = _createElementVNode("dt", null, "반품 배송비", -1)),
                          _createElementVNode("dd", null, _toDisplayString(returnShippingText.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (product.value.storeReturnPolicy)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(product.value.storeReturnPolicy), 1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "mpstore__policy",
                        innerHTML: returnPolicyHtml.value
                      }, null, 8, _hoisted_70))
                ], 512), [
                  [_vShow, activeTab.value === 'shipping']
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})